export function getRequestFailureCause(ex: unknown): unknown {
  const error = ex as Error | undefined;
  let cause: unknown = ex;

  if (process.env.NODE_ENV === 'development') {
    if (['TypeError', 'ConnectTimeoutError'].includes(error?.name ?? '')) {
      const name = error?.name;

      let parsedCause;
      try {
        parsedCause = error?.cause && JSON.stringify(error?.cause);
      } catch (e) {}

      const details = [error?.message, parsedCause && `(${parsedCause})`]
        .filter(Boolean)
        .join(' ');

      cause = `🛜 [${name}] ${details}`;
    }
  }

  return cause;
}
